import axios from 'axios';
import { Employee } from 'src/models/employee';

import { BASE_URL } from './config';
// Updated endpoint from '/api/matricula' to '/api/employee'
const ENDPOINT = '/api/employee';

export function getEmployeeId(employeeEmail: string) {
  const TOKEN = sessionStorage.getItem('Token');

  const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN,
    },
  });

  return apiClient.get<Employee>(`${ENDPOINT}/${employeeEmail}`);
}
